import styled from "styled-components";
import image from "assets/images/image-home.png";
import { Mouse } from "@styled-icons/boxicons-regular";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  background-color: white;
  position: relative;
  justify-content: center;

  @media screen and (max-width: 1010px) {
    flex-direction: column-reverse;
    flex-shrink: unset;
    flex-grow: unset;
    height: auto;
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;

  &.right {
    position: relative;
    max-width: 35%;
    align-items: center;
    background: rgb(109, 86, 255);
    background: linear-gradient(
      180deg,
      rgba(109, 86, 255, 1) 0%,
      rgba(165, 112, 255, 1) 100%
    );
  }

  @media screen and (max-width: 1010px) {
    max-width: 100%;

    &.left {
      padding: 110px 40px 48px 40px;
    }

    &.right {
      max-width: 100%;
    }
  }
`;

export const Wrapper = styled.div``;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 52px;
  line-height: 55px;
  letter-spacing: -4px;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 80px;

  span {
    display: block;
    font-family: ${fonts.BentonSansRegular};
    font-size: 21px;
    line-height: 22px;
    letter-spacing: 4px;
    text-transform: uppercase;

    &.moda {
      position: absolute;
      bottom: -22px;
      right: 22%;
    }
  }

  @media screen and (max-width: 1024px) {
    font-size: 40px;
    line-height: 43px;

    span {
      font-size: 18px;
      line-height: 19px;
    }
  }

  @media screen and (max-width: 1010px) {
    font-size: 44px;
    line-height: 47px;
    letter-spacing: -3px;
    margin-bottom: 32px;

    span {
      font-family: ${fonts.BentonSansWideBlack};
      letter-spacing: -3px;
      font-size: 44px;
      line-height: 47px;

      &.moda {
        position: relative;
        bottom: auto;
        right: auto;
      }
    }
  }

  @media screen and (max-width: 500px) {
    font-size: 36px;
    line-height: 36px;

    span {
      font-size: 36px;
      line-height: 36px;
    }
  }

  @media screen and (max-width: 414px) {
    font-size: 28px;
    line-height: 28px;

    span {
      font-size: 28px;
      line-height: 28px;
    }
  }

  @media screen and (max-width: 375px) {
    font-size: 24px;
    line-height: 24px;

    span {
      font-size: 24px;
      line-height: 24px;
    }
  }

  @media screen and (max-width: 320px) {
    font-size: 22px;
    line-height: 22px;

    span {
      font-size: 22px;
      line-height: 22px;
    }
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 505px;
  font-size: 15px;
  line-height: 22px;

  p {
    &.credit {
      margin-top: 40px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 2px;
      text-transform: uppercase;

      @media screen and (max-width: 500px) {
        max-width: 155px;
        letter-spacing: 1px;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    max-width: 450px;

    p.credit {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

export const Photo = styled.img.attrs({ src: image })`
  object-fit: contain;
  position: relative;
  left: -15%;

  @media screen and (max-width: 1024px) {
    height: 60%;
  }

  @media screen and (max-width: 1010px) {
    width: 100%;
    max-width: max-content;
    height: auto;
    left: auto;
    bottom: -100px;
  }
`;

export const ScrollInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 22px;
  font-family: ${fonts.BentonSansMedium};
  letter-spacing: 2px;
  color: black;
  text-transform: uppercase;
  position: absolute;
  bottom: 32px;

  pointer-events: none;
  z-index: 99;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const IconChevron = styled(Mouse).attrs({ size: 24 })`
  color: black;
  margin-left: 8px;
  transition: 300ms;
  animation-name: jump;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-iteration-count: infinite;

  @keyframes jump {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-5px);
    }
  }
`;
